import { StepModel } from '@hazmatsuite-next/ui';
import { EasyDgdStep } from '../models/easydgd.step.enum';

export const steps = (translations: any): StepModel<EasyDgdStep>[] => [
  {
    label: translations['EasyDgdCommonResource'] ? translations['EasyDgdCommonResource']['StepTransportMode'] : '',
    isActive: true,
    isDisabled: false,
    stepType: EasyDgdStep.TransportMode,
    show: true,
    relativeRoute: '../transportmode'
  },
  {
    label: translations['EasyDgdCommonResource'] ? translations['EasyDgdCommonResource']['StepGeneralInformation'] : '',
    isActive: false,
    isDisabled: true,
    stepType: EasyDgdStep.GeneralInformation,
    show: true,
    relativeRoute: '../generalinformation'
  },
  {
    label: translations['EasyDgdCommonResource'] ? translations['EasyDgdCommonResource']['StepPackingList'] : '',
    isActive: false,
    isDisabled: true,
    stepType: EasyDgdStep.PackingList,
    show: true,
    relativeRoute: '../packinglist'
  },
  {
    label: translations['EasyDgdCommonResource'] ? translations['EasyDgdCommonResource']['StepPreview'] : '',
    isActive: false,
    isDisabled: true,
    stepType: EasyDgdStep.Preview,
    show: true,
    relativeRoute: '../preview'
  },
  {
    label: translations['EasyDgdCommonResource'] ? translations['EasyDgdCommonResource']['StepDownload'] : '',
    isActive: false,
    isDisabled: true,
    stepType: EasyDgdStep.Download,
    show: true,
    relativeRoute: `../download`
  },
];
